let getters = {
    visibleRows: state => {
        return state.rows.filter(row => !row.hidden && (state.showInProgress || row.details.complete));
    },

    selectableRows: state => {
        return state.rows.filter(row => row.selectable);
    },

    selectedRows: state => {
        return state.rows.filter(row => row.selected)
    },

    selectedForGridView: state => {
        return state.rows.filter(row => row.selected && (!row.account.is_credit_card || !Number(row.details.balanceDue)))
    },

    hiddenRows: state => {
        return state.rows.filter(row => row.hidden)
    },

    specificPageRows: (state, getters) => () => {
        return getters.visibleRows;
    },

    clientSampleTypeNames: state => {
        var categories = [];
        state.clientSampleTypes.forEach(function(item) {
            var i = categories.map(function(c){ return c.category }).indexOf(item.category);
            if (i == -1) {
                i = categories.length;
                categories.push({ category: item.category, sampleTypes: [] });
            }
            if (categories[i].sampleTypes.map(function(st){ return st.toLowerCase() }).indexOf(item.sampleType.toLowerCase()) == -1) {
                var formula = (item.formula) ? item.formula + ' -- ' : '';
                categories[i].sampleTypes.push(formula + item.sampleType);
            }
        });
        return categories;
    },

    selectedDocTypeCodes: state => {
        var selected = state.docTypes.filter(docType => docType.selected);
        var docTypes = (selected.length || state.docTypes.length > 1) ? selected : state.docTypes;
        return docTypes.map(function(docType){
            return docType.document_type_cd
        });
    },

    availableReportTypes: state => {
        return state.rows.filter(row => row.type.code == 'report')
            .map(function(row) { return row.details.reportType.toLowerCase() })
            .filter((value,index,self) => { return self.indexOf(value) === index });
    },

    totalBalanceDue: state => {
        var balance = 0;
        state.rows.forEach(row => {
            if (row.account.is_credit_card) {
                if (row.details.balance) balance += parseInt(row.details.balance);
                else if (row.details.balanceDue) balance += parseInt(row.details.balanceDue);
            }
        })
        return balance;
    },

    availableReportFormats: state => (system, account_nbr) => {
        if (system && account_nbr && _.has(state.reportFormats, [account_nbr, system])) {
            return state.reportFormats[account_nbr][system];
        }

        return [];
    },
};

export default getters;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/documents/getters.js